import { LOW_STOCK_LIMITS } from '~~/constants/lowStockLimits';
import { LOW_STOCK_BOUNDARIES } from '~~/constants/pdpDetailSections';
import type { PriceRanges } from '~~/constants/priceRanges';
import { PRICE_RANGES } from '~~/constants/priceRanges';
import { countryCodes } from '~~/i18n';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';
import type { LowStockBoundary } from '~~/types/product/LowStockBoundaries';

function getLowStockBoundary(countryCode: CountryCodeValue): LowStockBoundary | undefined {

  return LOW_STOCK_BOUNDARIES[countryCode] ?? LOW_STOCK_BOUNDARIES[countryCodes.SK];

}

function getPriceRange(countryCode: CountryCodeValue, fullProductPrice: number): PriceRanges {

  const boundary = getLowStockBoundary(countryCode);

  if (!boundary) {

    return PRICE_RANGES.MID;
  
  }
  const { highBoundary, lowBoundary } = boundary;

  if (fullProductPrice > highBoundary) {

    return PRICE_RANGES.HIGH;
  
  } else if (lowBoundary <= fullProductPrice && fullProductPrice <= highBoundary) {

    return PRICE_RANGES.MID;
  
  } else {

    return PRICE_RANGES.LOW;
  
  }

}

function getLowStockLimit(priceRange: PriceRanges) {

  return LOW_STOCK_LIMITS[priceRange];

}

export function hasLowStock(countryCode: CountryCodeValue, fullProductPrice: number, stock: number): boolean {

  const priceRange = getPriceRange(countryCode, fullProductPrice);
  const stockLimit = getLowStockLimit(priceRange);

  if (stock <= stockLimit) {

    return true;
  
  }

  return false;

}
